import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import PerformanceReview from '../Administration/HomePage/PerformanceReview';

export default function PerformanceReviewComponent({ height }: { height: number }) {
    const theme = localStorage.getItem('theme') || 'light';
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Grid container spacing={2} sx={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography variant="h4" sx={{ fontSize: '1.5rem !important', textAlign: 'center', fontFamily: 'Trebuchet MS', fontWeight: 'bold' }}>Performance Review</Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center', fontFamily: 'Trebuchet MS', marginBottom: 2 }}>
                        Here you can see the company's performance review along with several other insights.
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Box style={{ maxWidth: '100% !important' }}>
                        <Grid container spacing={1} sx ={{ sm: 2, md: 3, lg: 12, xl: 12 }} >
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <PerformanceReview mode={theme} height={height} title='' />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}